import { ComponentProps } from 'react';

import clsx from 'clsx';

type SectionProps = ComponentProps<'section'>;

export function Section(props: SectionProps) {
  const { className, ...rest } = props;

  return <section className={clsx('flex flex-col gap-4 my-4 lg:my-12', className)} {...rest} />;
}
